import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  status: 'idle'
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setStatus(state, action) {
      return {
        ...state,
        status: action.payload
      }
    }
  }
})

export const selectAuthStatus = (state) => state.auth?.status ?? 'idle'
export const { setStatus } = authSlice.actions
export default authSlice.reducer
